export const SET_CURRENT_QUERY_TEXT = 'SET_CURRENT_QUERY_TEXT'
export const TOGGLE_MODAL_VISIBLE = 'TOGGLE_MODAL_VISIBLE'
export const SET_LAST_SELECTION = 'SET_LAST_SELECTION'
export const SET_NEW_CURRENT_COMPANY_ID = 'SET_NEW_CURRENT_COMPANY_ID'
export const SET_DATA_LOADING = 'SET_DATA_LOADING'
export const SET_DATA_LOADED = 'SET_DATA_LOADED'
export const SET_COMPANIES_DATA = 'SET_COMPANIES_DATA'
export const SET_ACCOUNTS_DATA = 'SET_ACCOUNTS_DATA'
export const SET_RECONCILIATION_TEXTS_DATA = 'SET_RECONCILIATION_TEXTS_DATA'
export const SET_WORKFLOWS_DATA = 'SET_WORKFLOWS_DATA'
export const SET_LIMIT = 'SET_LIMIT'
export const SET_RECENT_COMPANIES_DATA = 'SET_RECENT_COMPANIES_DATA'
export const SET_RECENT_TEMPLATES_DATA = 'SET_RECENT_TEMPLATES_DATA'
